<div class="bg-dentally-blue-300 flex items-center bg-opacity-25 p-4">
  <ng-icon name="heroQuestionMarkCircleSolid" size="16" class="text-dentally-blue-400 pr-4"></ng-icon>
  <p class="text-dentally-blue-700 font-normal">
    <ng-content></ng-content>
  </p>
</div>
